import { FC, useEffect, useState } from "react"
import styles from "./index.module.scss"



interface IProps {
    doneProjectsCount: number
    totalCommentsCount: number
    workInInstallments?: boolean
}

const CustomerRating: FC<IProps> = ({ doneProjectsCount, totalCommentsCount, workInInstallments }) => {
    const [translate, setTranslate] = useState(0)

    const rates = [
        ...workInInstallments ? [
            {
                icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.9834 9.99994L8.99173 12.0166L13.0167 7.98328" stroke="#FFF8ED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8.9584 2.04172C9.5334 1.55006 10.4751 1.55006 11.0584 2.04172L12.3751 3.17506C12.6251 3.39172 13.0917 3.56672 13.4251 3.56672H14.8417C15.7251 3.56672 16.4501 4.29172 16.4501 5.17506V6.59172C16.4501 6.91672 16.6251 7.39172 16.8417 7.64172L17.9751 8.95839C18.4667 9.53339 18.4667 10.4751 17.9751 11.0584L16.8417 12.3751C16.6251 12.6251 16.4501 13.0917 16.4501 13.4251V14.8417C16.4501 15.7251 15.7251 16.4501 14.8417 16.4501H13.4251C13.1001 16.4501 12.6251 16.6251 12.3751 16.8417L11.0584 17.9751C10.4834 18.4667 9.54173 18.4667 8.9584 17.9751L7.64173 16.8417C7.39173 16.6251 6.92506 16.4501 6.59173 16.4501H5.15006C4.26673 16.4501 3.54173 15.7251 3.54173 14.8417V13.4167C3.54173 13.0917 3.36673 12.6251 3.1584 12.3751L2.0334 11.0501C1.55007 10.4751 1.55007 9.54172 2.0334 8.96672L3.1584 7.64172C3.36673 7.39172 3.54173 6.92506 3.54173 6.60006V5.16672C3.54173 4.28339 4.26673 3.55839 5.15006 3.55839H6.59173C6.91673 3.55839 7.39173 3.38339 7.64173 3.16672L8.9584 2.04172Z" stroke="#FFF8ED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>,
                label: <>به‌صورت <span className="fw-700">اقساطی</span> کار می‌کند</>
            }
        ] : [],
        ...doneProjectsCount > 5 ? [{
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.6665 10.1666H12.4998" stroke="#FFF8ED" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6.6665 13.5H10.3165" stroke="#FFF8ED" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.33317 4.99996H11.6665C13.3332 4.99996 13.3332 4.16663 13.3332 3.33329C13.3332 1.66663 12.4998 1.66663 11.6665 1.66663H8.33317C7.49984 1.66663 6.6665 1.66663 6.6665 3.33329C6.6665 4.99996 7.49984 4.99996 8.33317 4.99996Z" stroke="#FFF8ED" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M13.3333 3.34998C16.1083 3.49998 17.5 4.52498 17.5 8.33331V13.3333C17.5 16.6666 16.6667 18.3333 12.5 18.3333H7.5C3.33333 18.3333 2.5 16.6666 2.5 13.3333V8.33331C2.5 4.53331 3.89167 3.49998 6.66667 3.34998" stroke="#FFF8ED" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            label: <>{doneProjectsCount} مشتری با این متخصص قرارداد بسته‌اند.</>
        }] : [],
        ...totalCommentsCount >= 15 ? [{
            icon: <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.9834 9.99994L8.99173 12.0166L13.0167 7.98328" stroke="#FFF8ED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.9584 2.04172C9.5334 1.55006 10.4751 1.55006 11.0584 2.04172L12.3751 3.17506C12.6251 3.39172 13.0917 3.56672 13.4251 3.56672H14.8417C15.7251 3.56672 16.4501 4.29172 16.4501 5.17506V6.59172C16.4501 6.91672 16.6251 7.39172 16.8417 7.64172L17.9751 8.95839C18.4667 9.53339 18.4667 10.4751 17.9751 11.0584L16.8417 12.3751C16.6251 12.6251 16.4501 13.0917 16.4501 13.4251V14.8417C16.4501 15.7251 15.7251 16.4501 14.8417 16.4501H13.4251C13.1001 16.4501 12.6251 16.6251 12.3751 16.8417L11.0584 17.9751C10.4834 18.4667 9.54173 18.4667 8.9584 17.9751L7.64173 16.8417C7.39173 16.6251 6.92506 16.4501 6.59173 16.4501H5.15006C4.26673 16.4501 3.54173 15.7251 3.54173 14.8417V13.4167C3.54173 13.0917 3.36673 12.6251 3.1584 12.3751L2.0334 11.0501C1.55007 10.4751 1.55007 9.54172 2.0334 8.96672L3.1584 7.64172C3.36673 7.39172 3.54173 6.92506 3.54173 6.60006V5.16672C3.54173 4.28339 4.26673 3.55839 5.15006 3.55839H6.59173C6.91673 3.55839 7.39173 3.38339 7.64173 3.16672L8.9584 2.04172Z" stroke="#FFF8ED" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>,
            label: <>{totalCommentsCount ?? 0} نظر ثبت شده برای این متخصص</>
        }] : [],
    ]


    useEffect(() => {
        let item = (rates.length - 1) || 0
        if (item >= 1) {
            const height = 25

            setInterval(() => {
                setTranslate(prev =>
                    (prev === (item * height)) ? 0 : prev + height
                )
            }, 3000)
        }
    }, [rates.length])



    return (
        <div className={styles.customer_rating}>
            <div
                className={styles.container__customer_rating + " flex flex-column gap-5"}
                style={{
                    transform: `translateY(-${translate}px)`
                }}
            >
                {
                    rates.map((res, index) =>
                        <div
                            key={index}
                            className="flex align-i-center gap-5"
                        >
                            {res?.icon}
                            <span>
                                {res?.label}
                            </span>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default CustomerRating